<template>
  <QStep
    v-on="$listeners"
    v-bind="$attrs"
    :name="name"
    :title="title || 'title'"
  >
    <template v-for="(index, name) in $slots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </QStep>
</template>

<script>
import { QStep } from 'quasar';

export default {
  name: 'SAIStep',
  props: {
    name: undefined,
    title: undefined
  },
  components: {
    QStep
  }
};
</script>
